import { useQuery } from '@tanstack/react-query';
import { DEFAULT_STRAPI_STALE_TIME } from '@betterpool/strapi-client';
import { useContext } from 'react';

import { LocationContext } from '~/components/providers/LocationProvider';
import { locationStorage } from '~/utils/locationStorage';

import getCmsPromoCarousel from './getCmsPromoCarousel';
import type { CarouselSpot } from './enums';

const useCmsPromoCarousel = (spot: CarouselSpot) => {
  const { locationCountryNameSafe } = useContext(LocationContext);

  const effectiveLocation =
    locationCountryNameSafe ?? locationStorage.getBestAvailableLocationCountry();

  return useQuery({
    queryKey: ['cms@promoCarousel', effectiveLocation, spot],
    queryFn: () => getCmsPromoCarousel(spot, effectiveLocation),
    staleTime: DEFAULT_STRAPI_STALE_TIME,
  });
};

export default useCmsPromoCarousel;
